import {IModel} from "makerjs";
import {DXFToModel, SVGToModel} from "@/functions/makerjs";

export default {
	state: {
		uploadedContent: '',
		originalFilename: '',
		originalFileType: '',
		isParsing: false,
	},
	getters: {
		uploadedContent: (state):string => state.uploadedContent,
		uploadAsModel: (state, getters):null|IModel => {
			if (getters.uploadedContent.length === 0) {
				return null;
			}

			// Handle SVG
			if ( state.originalFileType === "image/svg+xml" ) {
				return SVGToModel(getters.uploadedContent);
			}

			return DXFToModel(getters.uploadedContent);
		},
		getOriginalFilename: (state):string => state.originalFilename,
		getOriginalFileType: (state):string => state.originalFileType,
		getIsParsingFile: (state):boolean => state.isParsing
	},
	mutations: {
		setUploadedContent(state, {result, filename, filetype}): void {
			state.uploadedContent = result.trim();
			state.originalFilename = filename;
			state.originalFileType = filetype;
		},
		setParsingState(state, isParsing): void {
			state.isParsing = isParsing;
		}
	},
	actions: {
		updateUploadedContent({commit}, file): void {

			// If more than 2MB do not proceed
			if (file.size > 2000000) {
				return;
			}

			commit('setParsingState', true);
			const reader = new FileReader();
			reader.onload = function(e): void {
				commit('setUploadedContent', {result: e.target.result, filename: file.name, filetype: file.type});
				commit('setParsingState', false);
			};
			reader.readAsText(file);
		}
	}
};
